import { Box } from '@chakra-ui/react';

import GiveawayContent from 'View/productivity-host/component/giveaway-content';
import PromoContent from 'View/productivity-host/component/promo-content';
import TalkingPointContent from 'View/productivity-host/component/talking-point-content';
import { useBriefLiveState } from 'View/productivity-host/state';

import styles from './styles.module.css';

const ListContent = () => {
  const { state } = useBriefLiveState();
  const { selectedTab } = state;

  const content = {
    'talking-point': <TalkingPointContent />,
    giveaway: <GiveawayContent />,
    promo: <PromoContent />,
  };

  return <Box className={styles['list-content__container']}>{content?.[selectedTab]}</Box>;
};

export default ListContent;
